export class StrongoInvoiceHistory {
    public id: number | null;
    public invoice_id: number | null;
    public awb: string;
    public status: number | null;
    public error_message: string;
    public created_at: Date | null;
    public created_by_user_id: number | null;

    constructor(data: StrongoInvoiceHistoryData | void) {
        if (data === undefined) {
            this.id = null;
            this.invoice_id = null;
            this.awb = "";
            this.status = null;
            this.error_message = "";
            this.created_at = null;
            this.created_by_user_id = null;
        } else {
            this.id = data.id;
            this.invoice_id = data.invoice_id;
            this.awb = data.awb;
            this.status = data.status;
            this.error_message = data.error_message;
            this.created_at = null;
            if (data.created_at !== null) {
                this.created_at = new Date(data.created_at);
            }
            this.created_by_user_id = data.created_by_user_id;
        }
    }

}

export type StrongoInvoiceHistoryData = {
    id: number | null;
    invoice_id: number | null;
    awb: string;
    status: number | null;
    error_message: string;
    created_at: Date | null;
    created_by_user_id: number | null;

}